
    export default {
        name: 'PageChangeAnimation',
        computed: {
            isAnimationActive() {
                return this.$store.state.pageChangeAnimation;
            },
        },
    };
